/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'newsfeed': {
    width: 24,
    height: 24,
    viewBox: '0 0 24 24',
    data: '<defs><path pid="0" d="M18 3a3 3 0 013 3v12a3 3 0 01-3 3H6a3 3 0 01-3-3V6a3 3 0 013-3h12zm0 2H6a1 1 0 00-1 1v12a1 1 0 001 1h12a1 1 0 001-1V6a1 1 0 00-1-1zM7 8a1 1 0 001 1c3.877 0 7 3.123 7 7a1 1 0 002 0c0-4.959-4.041-9-9-9a1 1 0 00-1 1zm0 4a1 1 0 001 1c1.668 0 3 1.332 3 3a1 1 0 002 0c0-2.75-2.25-5-5-5a1 1 0 00-1 1zm1 3a1 1 0 100 2 1 1 0 000-2z" id="svgicon_newsfeed_a"/></defs><use _fill="#000" fill-rule="nonzero" xlink:href="#svgicon_newsfeed_a"/>'
  }
})
